module.exports = {
  "country": "MT",
  "artist": "Gianluca Bezzina",
  "song": "Tomorrow",
  "year": "2013",
  "place": "8",
  "spotify": "2bAxsFjz7oWBETBdC0o6sy"
};